import conversions from 'utils/conversions.js';

export default {
  /**
   * お客様情報
   */
  applicant: {
    address1st: null,
    address2nd: null,
    deliveryAt: function () {
      let ret = null;
      if (this.deliveryAtYear && this.deliveryAtMonth && this.deliveryAtDay) {
        ret = `${this.deliveryAtYear}-${this.deliveryAtMonth}-${this.deliveryAtDay}`;
      }
      return ret;
    },
    deliveryAtDay: '',
    deliveryAtMonth: '',
    deliveryAtYear: '',
    email: null,
    nameKana: null,
    name: null,
    partnerUserId: null,
    postCode: null,
    prefecture: '',
    remarks: null,
    tel: null,
  },
  /**
   * カート商品リスト
   */
  cartItems: [],
  /**
   * 発送手数料
   */
  // carriage: 0,
  /**
   * お届け先情報
   */
  delivery: {
    address1st: null,
    address2nd: null,
    name: null,
    nameKana: null,
    postCode: null,
    prefecture: '',
    tel: null,
  },
  /**
   * お支払い情報
   */
  payment: {
    payAtDay: '',
    payAtMonth: '',
    payAtYear: '',
    payAt: function () {
      let ret = null;
      if (this.payAtYear && this.payAtMonth && this.payAtDay) {
        ret = `${this.payAtYear}-${this.payAtMonth}-${this.payAtDay}`;
      }
      return ret;
    },
    payBy: '',
  },
  /**
   * 発送手数料を取得する
   * @returns 発送手数料
   */
  getCarriage: function () {
    if (!this.isRequiredCarriage()) return 0;
    const totalPriceOfProducts = this.getTotalPriceOfProducts();
    if (1 <= totalPriceOfProducts && totalPriceOfProducts < 33000) return 1650;
    return 0;
  },
  /**
   * 入力概要を取得する
   * @returns 入力概要
   */
  getInputSummary: function () {
    if (this.applicant === null || this.delivery === null || this.payment === null)
      return {
        title: 'こちらをクリックすると入力内容をご確認いただけます。',
        categories: [],
      };
    const NOT_ENTERED = '(未入力)';
    return {
      title: 'こちらをクリックすると入力内容をご確認いただけます。',
      categories: [
        {
          name: 'お客様情報',
          items: [
            {
              key: 'お名前',
              value: conversions.toConfirmationLabelForString(this.applicant.name),
            },
            {
              key: 'お名前（カナ）',
              value: conversions.toConfirmationLabelForString(this.applicant.nameKana),
            },
            {
              key: '郵便番号',
              value: conversions.toConfirmationLabelForString(this.applicant.postCode),
            },
            {
              key: '都道府県',
              value: conversions.toConfirmationLabelForString(this.applicant.prefecture),
            },
            {
              key: '市区町村、丁目・番地',
              value: conversions.toConfirmationLabelForString(this.applicant.address1st),
            },
            {
              key: '建物名など',
              value: conversions.toConfirmationLabelForString(this.applicant.address2nd),
            },
            {
              key: '電話番号',
              value: conversions.toConfirmationLabelForString(this.applicant.tel),
            },
            {
              key: 'e-mail（PC・携帯）',
              value: conversions.toConfirmationLabelForString(this.applicant.email),
            },
            {
              key: '納品希望日',
              value: conversions.toConfirmationLabelForDate(
                this.applicant.deliveryAtYear,
                this.applicant.deliveryAtMonth,
                this.applicant.deliveryAtDay
              ),
            },
          ],
        },
        {
          name: 'お届け先情報',
          items: [
            {
              key: 'お名前',
              value: conversions.toConfirmationLabelForString(this.delivery.name),
            },
            {
              key: 'お名前（カナ）',
              value: conversions.toConfirmationLabelForString(this.delivery.nameKana),
            },
            {
              key: '郵便番号',
              value: conversions.toConfirmationLabelForString(this.delivery.postCode),
            },
            {
              key: '都道府県',
              value: conversions.toConfirmationLabelForString(this.delivery.prefecture),
            },
            {
              key: '市区町村、丁目・番地',
              value: conversions.toConfirmationLabelForString(this.delivery.address1st),
            },
            {
              key: '建物名など',
              value: conversions.toConfirmationLabelForString(this.delivery.address2nd),
            },
            {
              key: '電話番号',
              value: conversions.toConfirmationLabelForString(this.delivery.tel),
            },
          ],
        },
        {
          name: 'その他の情報',
          items: [
            {
              key: '備考',
              value: conversions.toConfirmationLabelForString(this.applicant.remarks),
            },
          ],
        },
      ],
    };
  },
  /**
   * リクエストボディを取得する
   * @returns リクエストボディ
   */
  getRequestBodyForRegister: function () {
    if (!this.applicant) return null;
    if (!this.cartItems) return null;
    //if (!this.carriage) return null;
    if (!this.delivery) return null;
    if (!this.payment) return null;

    let products = [];
    // 商品を設定する
    this.cartItems.forEach((cartItem) => {
      let summary = cartItem.product.nameJa;
      summary += cartItem.product.colorJa ? ` / ${cartItem.product.colorJa}` : '';
      summary += cartItem.product.sizeJa ? ` / ${cartItem.product.sizeJa}` : '';
      products.push({
        product_id: cartItem.productId,
        name: cartItem.product.nameJa,
        product_no: cartItem.product.productNo,
        color: cartItem.product.colorJa,
        size: cartItem.product.sizeJa,
        summary: summary,
        selling_price: cartItem.product.sellingPrice,
        quantity: cartItem.quantity,
      });
    });

    // 発送手数料を設定する
    products.push({
      product_id: 0,
      name: '発送手数料',
      product_no: 'N/A',
      color: null,
      size: null,
      summary: '発送手数料',
      selling_price: this.getCarriage(),
      quantity: 1,
    });

    // お客様情報、お届け先情報、お支払い情報を設定する
    let shoppingOrder = {
      shopping_order: {
        address_1st: this.applicant.address1st,
        address_2nd: this.applicant.address2nd,
        delivery_at: this.applicant.deliveryAt(),
        email: this.applicant.email,
        name_kana: this.applicant.nameKana,
        name: this.applicant.name,
        partner_user_id: this.applicant.partnerUserId,
        postcode: this.applicant.postCode,
        prefecture: this.applicant.prefecture,
        remarks: this.applicant.remarks,
        phone_no: this.applicant.tel,
        delivery_address_1st: this.delivery.address1st,
        delivery_address_2nd: this.delivery.address2nd,
        delivery_name: this.delivery.name,
        delivery_name_kana: this.delivery.nameKana,
        delivery_postcode: this.delivery.postCode,
        delivery_prefecture: this.delivery.prefecture,
        delivery_phone_no: this.delivery.tel,
        pay_at: this.payment.payAt(),
        pay_by: this.payment.payBy,
        shopping_order_details: products,
      },
    };
    return shoppingOrder;
  },
  /**
   * 商品の合計額を取得する
   * @returns 商品の合計額
   */
  getTotalPriceOfProducts: function () {
    let totalPrice = 0;
    this.cartItems.forEach((cartItem) => {
      if (cartItem.subTotal && !isNaN(cartItem.subTotal)) totalPrice += cartItem.subTotal;
    });
    return totalPrice;
  },
  /**
   * カートの合計額を取得する
   * @returns 商品の合計額
   */
  getTotalPriceWithTax: function () {
    return this.getTotalPriceOfProducts() + this.getCarriage();
  },
  /**
   * 送料必要可否を取得する
   * @returns
   */
  isRequiredCarriage: function () {
    // 送料が必要な商品を返す
    const cartItems = this.cartItems.filter((item) => {
      return item.product.carriageRequired === true;
    });
    return cartItems && cartItems.length > 0;
  },
  /**
   * 登録時レスポンス
   */
  registerResponse: {
    message: null,
    status: null,
    payBy: null,
    redirectUrl: null,
  },
};
